import { render, staticRenderFns } from "./TicketsInPast3Years.vue?vue&type=template&id=bc2814fe&"
import script from "./TicketsInPast3Years.vue?vue&type=script&lang=js&"
export * from "./TicketsInPast3Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports